import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from '../services/util.service';

@Pipe({
  name: 'formattedPhoneNumber'
})
export class FormattedPhoneNumberPipe implements PipeTransform {

  constructor(private readonly utilService: UtilService) { }
  
  transform(phoneNumber: string): string {       
    return this.utilService.formatPhoneNumber(phoneNumber);
  }

}
